export const SUPPORT_EMAIL = 'hello@fusegrid.io'

/** A support email that carries where the advisor was, so we can answer without a round of questions.
 * With `text` the advisor's own words lead the body; with `labels` (FE:C11 triage) the subject carries
 * the routing labels. Labels only route the request: nobody answers on the advisor's behalf. */
export function supportMailto(context: { from?: string | null; userAgent?: string | null; text?: string | null; labels?: string[] | null } = {}): string {
  const said = (context.text || '').trim()
  const lines = [
    ...(said ? [said, ''] : ['What were you trying to do?', '', '', 'What happened instead?', '', '']),
    '---',
    `Page: ${context.from || 'not given'}`,
    `Browser: ${context.userAgent || 'unknown'}`,
  ]
  const labels = (context.labels || []).map(label => `[${label}]`).join('')
  const subject = labels ? `FuseGrid support request ${labels}` : 'FuseGrid support request'
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(lines.join('\n'))}`
}
